import { RadioController } from "./radio";

class RadioItemController {
  isChecked: boolean;
  item: any;
  itemContent: any;
  radioController: RadioController;
  name: string;
  index: number;
  ariaLabel: string;
  dataBiName: string;
  // @ngInject
  constructor(
    private $timeout: ng.ITimeoutService,
    private $scope: ng.IScope,
    private $element: ng.IAugmentedJQuery,
    private $sce: ng.ISCEService
  ) {}

  $postLink() {
    this.name = this.radioController.name;
    this.itemContent = this.$sce.trustAsHtml(this.item);
    this.$scope.$applyAsync(() => {
      let radioContent = this.$element.find(".sd-radio-item-content-html");
      this.ariaLabel = radioContent.find("[aria-label]").attr("aria-label");
      this.dataBiName = radioContent.find("[data-bi-name]").attr("data-bi-name");
    });
  }

  public getBIId() {
    return `${this.name}: radio item ${this.index + 1}`;
  }
}
export const sdRadioItemHtml: ng.IComponentOptions = {
  bindings: {
    item: "<",
    model: "=",
    index: "<"
  },
  controller: RadioItemController,
  templateUrl: "../ShellCommon/controls/radio/radio-item-html.html",
  require: {
    radioController: "^sdRadio"
  }
};
